var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 3.33398H16.666C17.5827 3.33398 18.3327 4.08398 18.3327 5.00065V15.0007C18.3327 15.9173 17.5827 16.6673 16.666 16.6673H3.33268C2.41602 16.6673 1.66602 15.9173 1.66602 15.0007V5.00065C1.66602 4.08398 2.41602 3.33398 3.33268 3.33398Z",
    stroke: "#454551",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 5L9.99935 10.8333L1.66602 5",
    stroke: "#454551",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailMessage);
export default __webpack_public_path__ + "static/media/mail-message.0ac5239ea96703e4a64dc79903c6ea43.svg";
export { ForwardRef as ReactComponent };